
import { config } from "@backstagex/core/src/config";

const fields = [
  {
    type: 'bsx-select',
    label: '可參與身分別',
    model: 'role',
    required: true,
    values() {
      return [
        { 'id': 0, 'name': "訪客" },
        { "id": 1, "name": "媽媽" },
        { "id": 2, "name": "員工" }
      ];
    },
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '類型名稱',
    model: 'name',
    placeholder: '類型名稱',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '小標題',
    model: 'sub_title',
    placeholder: '小標題',
  },
  {
    type: 'bsx-select',
    label: '所屬院區',
    model: 'branch_id',
    required: false,
    help: "用於「關於禾馨 - 禾馨據點」",
    values() {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", config.apiHost + '/api/backstagex/' + this.$route.params.menuItemKey + '/hospital-branch-list-optional', false);
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + localStorage.token);
      xmlHttp.send();
      return JSON.parse(xmlHttp.responseText).data.data;
    },
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-upload",
    label: "照片",      
    model: "image",
    kind: "button",
    required: true,
    browse: true,
    preview: true,
    accept: ".jpg,.png",
    folder: "course_type",
    validator: function () {
      this.validation();
    },
  },
  {
    type: "x-QuillEditor",
    label: "描述",
    model: "info",
  },
  {
    type: 'bsx-select',
    label: '預約方式',
    model: 'method',
    required: true,
    values() {
      return [
        { 'id': 0, 'name': "系統預約" },
        { "id": 1, "name": "電話預約" }
      ];
    },
    validator: function () {
      this.validation();
    },
  },
];

export default fields;
